// date-fns v4 dropped submodule default exports, but the app imports
// `subDays` as a default. Re-export the v4 NAMED export as a plain-CJS
// module so babel `_interopRequireDefault` wraps it → `.default` is the fn.
module.exports = require("date-fns").subDays;
